import { FC } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ConfirmationDeleteIcon: FC<SvgIconProps> = (props) => (
	<SvgIcon {...props}>
		<svg
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			stroke="currentColor"
		>
			<path
				d="M9.5 12.5H30.5V32C30.5 32.7956 30.1837 33.5586 29.6211 34.1213C29.0585 34.6839 28.2956 35 27.5 35H12.5C11.7043 35 10.9411 34.6839 10.3785 34.1213C9.81593 33.5586 9.5 32.7956 9.5 32V12.5Z"
				stroke-width="3"
				stroke-miterlimit="10"
			/>
			<path
				d="M5 12.5H10.4748C11.0714 12.4988 11.6541 12.3198 12.1484 11.9858C12.6427 11.6519 13.0263 11.178 13.25 10.625L14.75 6.89001C14.9714 6.33419 15.3538 5.85717 15.8483 5.52039C16.3427 5.1836 16.9265 5.00241 17.5248 5H22.4748C23.0731 5.00241 23.6569 5.1836 24.1514 5.52039C24.6458 5.85717 25.0286 6.33419 25.25 6.89001L26.75 10.625C26.9746 11.1804 27.3602 11.6559 27.8574 11.99C28.3547 12.3242 28.9407 12.5018 29.5398 12.5H35"
				stroke-width="3"
				stroke-miterlimit="10"
			/>
		</svg>
	</SvgIcon>
);
